import { Avatar, Link as ChakraLink, LinkBox } from '@chakra-ui/react';
import { User } from '@/types/core/User';
import Link from 'next/link';

type TMemberPreviewProps = {
  user: User
}

export default function MemberPreview({
  user
}: TMemberPreviewProps) { 
  return (
    <LinkBox
      display="flex"
      alignItems="center"
      gap={['1rem', '1.25rem']}
      transition="all 0.2s ease-in-out"
    >
      <Avatar src={user.avatar.filename} name={user.displayName} w="4.5rem" h="4.5rem" />
      
      <Link href={{pathname: '/profil', query: {user: user.id, slug: user.slug}}} as={`/utilisateur/${user.slug}/${user.id}`} passHref>        
        <ChakraLink>
          {user.displayName}
        </ChakraLink>
      </Link>
    </LinkBox>
  );
}
